<template>
  <pt-coupon-form v-loading="loading" ref="form" class="pt-coupon-form__withData" :form="formValue" :groupList="groupList" @isUpload="isUpload" :isEdit="isEdit" :provincesList="provincesList"></pt-coupon-form>
</template>

<script>
import PtCouponForm from './form'
import { cashCount } from '@/utils/formUtils'
import { couponTypeHasLimit } from 'json/mall-options'
// import { getGoodsBelongLabel } from '../promotion-option'
export default {
  name: 'pt-coupon-form__withData',
  components: {
    'pt-coupon-form': PtCouponForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      formValue: {},
      couponDetail: {},
      groupList: [],
      loading: false,
      isUploading: false,
      provincesList: []
    }
  },
  methods: {
    getProvincesList () {
      let data = {
        provinceGbCode: 0,
        cityGbCode: 0
      }
      this.$store.dispatch('getDivision', data).then(res => {
        this.provincesList = this.getNameToCode(res, 'province')
      }).catch(err => {
        this.$message.error(err || '获取省/市/区列表失败')
      })
    },
    getNameToCode (Arry, name) {
      Arry.forEach(item => {
        let value = {
          provinceGbCode: item.gbCode,
          provinceName: item.province
        }
        this.$set(item, 'value', JSON.stringify(value))
      })
      return Arry
    },
    isUpload (val) {
      this.isUploading = val
    },
    getCouponDetail () {
      this.loading = true
      this.$store.dispatch('couponDetail', this.id).then(res => {
        this.loading = false
        this.formValue = this.changeForm(res)
        this.couponDetail = res
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取优惠劵详情失败')
      })
    },
    changeForm (val) {
      this.$set(val, 'excel', val.codeExcel)
      return val
    },
    // 判断是否已选择用户
    isSelectedUser () {
      let importCustomer = false
      let formValue = this.form.formValue
      if (formValue.mallUserCriteria && formValue.mallUserCriteria && formValue.mallUserCriteria.whiteList &&
      formValue.mallUserCriteria.whiteList.length) {
        formValue.mallUserCriteria.whiteList.forEach(item => {
          for (let key in item) {
            if (item[key] || item.bindCps === false) {
              importCustomer = true
            }
          }
        })
      }
      return importCustomer
    },
    // 编辑的时候，新选择用户，如果有导入的数据，删除上次导入数据
    editHasImportData () {
      let obj = {
        importCustomerDetail: false
      }
      if (this.couponDetail.mallUserCriteria && this.couponDetail.mallUserCriteria && this.couponDetail.mallUserCriteria.whiteList &&
      this.couponDetail.mallUserCriteria.whiteList.length) {
        this.couponDetail.mallUserCriteria.whiteList.forEach(item => {
          if (item.userListId) {
            obj.importCustomerDetail = true
            obj.userListId = item.userListId
          }
        })
      }
      return obj
    },
    submit (type) {
      if (this.isUploading) {
        this.$message.error('请等待兑换码列表上传完毕再点击')
      } else {
        this.form.validate().then(formValue => {
          if (!formValue.couponData.startTime || !formValue.couponData.endTime) {
            this.$message.error('请指定优惠劵有效期')
          } else if ((formValue.grantType === 'GRANT' || formValue.grantType === 'RECEIVE') && formValue.grantObject === 'DESIGNATED_USER' && !this.isSelectedUser()) {
            this.$message.error('请选择用户')
          } else {
            formValue.couponData.thresholdOfAmount = cashCount(formValue.couponData.thresholdOf_amount)
            // formValue.goodsLimitation = !!((formValue.goodsIds && formValue.goodsIds.length > 0))
            // 发放数量判断
            // formValue.amount = couponTypeHasLimit(formValue.grantType) ? formValue.amount : null
            // 发放对象判断
            //   formValue.grantObject = !couponTypeHasLimit(formValue.grantType) ? 'ALL_USER' : formValue.grantObject
            if (formValue.grantObject === 'ALL_USER') {
              formValue.designatedUserIds = null
            }
            //   formValue.limit = formValue.grantType === 'BY_OTHER_PROMOTION' ? false : formValue.limit
            if (formValue.couponData.goodsIds && formValue.couponData.goodsIds.length > 0) {
              formValue.couponData.goodsLimitation = true
            } else {
              formValue.couponData.goodsLimitation = false
            }
            this.submitCoupon(formValue, type)
          }
        })
      }
    },
    async submitCoupon (formValue, type) {
      let apiUrl
      if (this.isEdit) {
        apiUrl = type === 'save' ? 'couponEdit' : 'createCoupons'
      } else {
        apiUrl = 'createCoupons'
        if (type === 'save') {
          apiUrl = 'saveCoupons'
        }
      }
      let data = {
        ...formValue,
        limit: couponTypeHasLimit(formValue)
        // amount: formValue.amount
      }
      this.$emit(type === 'save' ? 'saveLoad' : 'submitLoad')
      data.id = this.isEdit ? this.id : null
      // if (this.isUploading) {
      //   this.$message.error('请等待兑换码列表上传完毕再点击')
      //   return
      // }
      if (data.excel) {
        data.excel = data.excel.url
      }
      this.$store.dispatch(apiUrl, data).then(res => {
        // doing something ...
        this.$message.success((type === 'save' ? '保存' : '提交') + '成功')
        history.go(-1)
        this.$emit('submitSuccess', true)
      }).catch(errorMessage => {
        this.$emit('submitSuccess', true)
        this.$message.error(errorMessage)
      })
    },
    getGroupList () {
      let data = {
        example: {},
        pageable: {
          page: 0,
          size: 99999
        }
      }
      this.$store.dispatch('getGoodsGroup', data).then(res => {
        this.groupList = res.data
        res.data.forEach((item, index) => {
          if (item.id === 'gene-unlock') {
            res.data.splice(index, 1)
          }
        })
        this.groupTabs = res.data
        this.selectTab = res.data[0].id
      }).catch(err => {
        this.$message(err || '获取商品分组列表失败')
      })
    }
  },
  created () {
    this.getProvincesList()
    this.getGroupList()
    if (this.isEdit) {
      this.getCouponDetail()
    }
  }
}
</script>
